import API from "shared/services/Api";
import { ITimeTable, ITimeTableResponse } from "shared/types/Time";

export const getTimeTable = async (
  data: ITimeTable
): Promise<ITimeTableResponse> =>
  API.get(
    `/oc/dentist/schedules?id=${data.id}&date=${data.date}&interval=${data.interval}&separetor=${data.separator}&idProcedure=${data.idProcedure}&idDent=${data.idDent}&idPac=${data.idPac}`
  );
